"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertiesComponent = void 0;
const core_1 = require("@angular/core");
const common_1 = require("@angular/common");
const properties_service_1 = require("../../../services/properties.service");
const file_icon_component_1 = require("../explorer/file-icon.component");
let PropertiesComponent = class PropertiesComponent {
    constructor() {
        this.propertiesService = (0, core_1.inject)(properties_service_1.PropertiesService);
        this.context = this.propertiesService.context;
        this.itemType = (0, core_1.computed)(() => {
            const item = this.context()?.item;
            if (!item)
                return '';
            switch (item.type) {
                case 'folder': return 'File folder';
                case 'shortcut': return 'Shortcut (.lnk)';
                default:
                    const ext = item.name.split('.').pop()?.toUpperCase();
                    return ext ? `${ext} File` : 'File';
            }
        });
        this.fullPath = (0, core_1.computed)(() => {
            const ctx = this.context();
            if (!ctx)
                return '';
            return ctx.path.endsWith('/') ? `${ctx.path}${ctx.item.name}` : `${ctx.path}/${ctx.item.name}`;
        });
    }
};
exports.PropertiesComponent = PropertiesComponent;
exports.PropertiesComponent = PropertiesComponent = __decorate([
    (0, core_1.Component)({
        selector: 'app-properties',
        template: `
<div class="h-full w-full bg-zinc-800 text-white p-4 text-sm select-none">
  @if (context(); as ctx) {
    <div class="flex flex-col h-full">
      <!-- Header -->
      <div class="flex items-center gap-4 pb-4 border-b border-white/10">
        <app-file-icon [type]="ctx.item.type" [name]="ctx.item.name"></app-file-icon>
        <h1 class="text-lg font-semibold truncate">{{ ctx.item.name }}</h1>
      </div>

      <!-- Properties List -->
      <div class="py-4 space-y-3 flex-grow overflow-y-auto">
        <div class="grid grid-cols-3 gap-2">
          <span class="text-gray-400">Type of file:</span>
          <span class="col-span-2 truncate">{{ itemType() }}</span>
        </div>
        @if (ctx.item.type === 'shortcut' && ctx.item.targetPath) {
           <div class="grid grid-cols-3 gap-2">
            <span class="text-gray-400">Target:</span>
            <span class="col-span-2 truncate" [title]="ctx.item.targetPath">{{ ctx.item.targetPath }}</span>
          </div>
        }
        <div class="grid grid-cols-3 gap-2">
          <span class="text-gray-400">Location:</span>
          <span class="col-span-2 truncate" [title]="ctx.path">{{ ctx.path }}</span>
        </div>
        @if (ctx.item.size) {
           <div class="grid grid-cols-3 gap-2">
            <span class="text-gray-400">Size:</span>
            <span class="col-span-2">{{ ctx.item.size }}</span>
          </div>
        }
        <hr class="border-white/10 !my-4">
        <div class="grid grid-cols-3 gap-2">
          <span class="text-gray-400">Modified:</span>
          <span class="col-span-2">{{ ctx.item.modified }}</span>
        </div>
      </div>
      
       <!-- Footer -->
       <div class="flex justify-end pt-4 border-t border-white/10">
         <button class="px-6 py-1.5 bg-blue-600 text-white rounded text-sm font-semibold hover:bg-blue-500">OK</button>
       </div>
    </div>
  } @else {
    <div class="flex items-center justify-center h-full text-gray-500">
      No item selected.
    </div>
  }
</div>`,
        changeDetection: core_1.ChangeDetectionStrategy.OnPush,
        imports: [common_1.CommonModule, file_icon_component_1.FileIconComponent]
    })
], PropertiesComponent);
